
export interface TemplateSelection {
    "Event Seqeunce Diagram": string
    "Fault Tree": string
    "Bayesian Network": string
}

class VersionTemplateManager {

    // this is the key for local storage
    LOCAL_STORAGE_KEY = 'templates'

    DEFAULT_TEMPLATE_VERSIONS: TemplateSelection = {
        "Event Seqeunce Diagram": "v1",
        "Fault Tree": "v1",
        "Bayesian Network": "v1"
    }

    templates: TemplateSelection

    /**
     * Initializes the object by setting templates field to stored/default value
     */
    constructor() {
        this.templates = this.getStoredSelectedTemplates()
    }

    /**
     * Gets template data from local storage or returns the default values
     * @returns TemplateSelection - the selected template version for each tree type
     */
    getStoredSelectedTemplates = (): TemplateSelection =>{
        const templates = localStorage.getItem(this.LOCAL_STORAGE_KEY)
        if (templates){
            return JSON.parse(templates)
        } else {
            return {...this.DEFAULT_TEMPLATE_VERSIONS}
        }
    }

    /**
     * Stores the template data in local storage
     * @param newSelection TemplateSelection - the selected template version for each tree type
     */
    setStoredTemplates = (newSelection: TemplateSelection): void =>{
        const stringifiedNewSelection = JSON.stringify(newSelection)
        localStorage.setItem(this.LOCAL_STORAGE_KEY, stringifiedNewSelection)
    }

}

export default VersionTemplateManager